<i18n
  src="@/locales/views/organization/production/productivity_by_producer_exp/show_producer.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process')"
    :params="{
      organization_id: organization_id,
      harvest_process_id: harvest_process_id
    }"
  />

  <template v-if="load_general_data">
    <bread-crumbs :labels="[module_name, harvest_process.name]" />

    <div class="panel">
      <div class="panel-header">
        <h3>{{ $t("model.producer.self") }}</h3>
      </div>
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.organization_producer.producer_code") }}
              </dt>
              <dd class="content-data">
                {{ producer.org_producer_code }}
              </dd>
            </div>

            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.producer_code") }}
              </dt>
              <dd class="content-data">
                {{ producer.producer_code }}
              </dd>
            </div>

            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.lastname") }} y
                {{ $t("model.producer.name") }}
              </dt>
              <dd class="content-data">
                {{ producer.fullname }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- monthly -->
    <div class="mt-8 flex flex-row justify-between">
      <h1 class="page-title pl-2">
        <i class="fa-solid fa-chart-line-up"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_monthly") }}
      </h1>
    </div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="mt-6 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.crop_field.self") }}
                    </th>
                    <td scope="col" class="table-header-cell" v-for="crop_field in crop_fields_m" :key="crop_field.id">
                      {{ crop_field.name }}
                    </td>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr class="table-row">
                    <td scope="col" class="table-header-cell">
                      {{ $t("model.crop_field.hectares") }}
                    </td>
                    <td class="table-cell" v-for="crop_field in crop_fields_m" :key="crop_field.id">
                      {{ crop_field.hectares }}
                    </td>
                  </tr>
                  <tr class="table-row">
                    <td scope="col" class="table-header-cell">
                      {{ $t("labels.total_exported") }}
                    </td>
                    <td class="table-cell" v-for="crop_field in crop_fields_m" :key="crop_field.id">
                      {{ totalExportedByCropField(crop_field) }}
                    </td>
                  </tr>
                  <tr class="table-row" v-for="(month, index) in months" :key="index">
                    <td scope="col" class="table-header-cell">
                      {{ months_modified[index] }}
                    </td>
                    <td class="table-cell" v-for="crop_field in crop_fields_m" :key="crop_field.id">
                      {{ productivityMonthly(crop_field.productivity, month) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <monthly-report-chart
            :data="crop_fields_m"
            :months="months_modified"
            >
          </monthly-report-chart>
        </div>
      </div>
    </div>

    <!-- weekly -->
    <div class="mt-8 flex flex-row justify-between">
      <h1 class="page-title pl-2">
        <i class="fa-solid fa-chart-line-up"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_weekly") }}
      </h1>
    </div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
    <div class="mt-6 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field.self") }}
                  </th>
                  <td scope="col" class="table-header-cell" v-for="crop_field in crop_fields_w" :key="crop_field.id">
                    {{ crop_field.name }}
                  </td>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr class="table-row" v-for="([week, year], index) in weeks" :key="index">
                  <td class="table-header-cell">{{ week }}</td>
                  <td class="table-cell" v-for="crop_field in crop_fields_w" :key="crop_field.id">
                    {{ productivityWeekly(crop_field.productivity, week, year) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
      <div class="panel">
        <div class="panel-body">
          <weekly-report-chart
            :data="crop_fields_w"
            :weeks="weeks_modified"
            >
          </weekly-report-chart>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import MonthlyReportChart from "@/components/views/organization/production/productivity_by_producer_exp/show_producer/MonthlyReport.vue";
import WeeklyReportChart from "@/components/views/organization/production/productivity_by_producer_exp/show_producer/WeeklyReport.vue";
import Requester from "@/views/organization/requesters/production/productivity_by_producer_exp/show_producer.js";

export default {
  name: "ORGProductionProductivityByProducerExpShowProducer",
  components: { MonthlyReportChart, WeeklyReportChart },
  data() {
    return {
      load_general_data: false,
      harvest_process: {},
      producer: {},
      crop_fields_m: [],
      months: [],
      crop_fields_w: [],
      weeks: []
    };
  },
  props: {
    organization_id: { required: true },
    harvest_process_id: { required: true },
    producer_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  },
  computed: {
    months_modified: function () {
      const mths = this.months.map(month => month.split(" "));

      if (
        mths
          .map(item => item[1])
          .filter((year, index, array) => array.indexOf(year) === index)
          .length == 1
      ) {
        return mths.map(item => item[0]);
      }
      return mths.map(item => item.join(" "));
    },
    weeks_modified: function () {
      if (
        this.weeks
          .map(item => item[1])
          .filter((year, index, array) => array.indexOf(year) === index)
          .length == 1
      ) {
        return this.weeks.map(item => item[0]);
      }
      return this.weeks.map(item => item.join(" "));
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchHarvestProcess();
      await this.fetchProducer();
      await this.fetchProductivityMonthly();
      await this.fetchProductivityWeekly();
      this.load_general_data = true;
    },
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_process = response.data;
    },
    fetchProducer: async function () {
      let response = await Requester.fetchProducer(
        this.organization_id,
        this.harvest_process_id,
        this.producer_id
      );
      this.producer = response.data;
    },
    fetchProductivityMonthly: async function () {
      let response = await Requester.fetchProductivityMonthly(
        this.organization_id,
        this.harvest_process_id,
        this.producer_id
      );
      this.crop_fields_m = response.data.crop_fields;
      this.months = response.data.months;
    },
    fetchProductivityWeekly: async function () {
      let response = await Requester.fetchProductivityWeekly(
        this.organization_id,
        this.harvest_process_id,
        this.producer_id
      );
      this.crop_fields_w = response.data.crop_fields;
      this.weeks = response.data.weeks;
    },
    totalExportedByCropField: function (crop_field) {
      const total = crop_field.productivity.reduce(
        (sum, item) => sum + Number(item.total_exported),
        0
      );
      return this.numberWithPrecision(total);
    },
    productivityMonthly: function (productivity, month) {
      const prod = productivity.find(prod => prod.month == month)?.productivity;
      return this.numberWithPrecision(prod, 2);
    },
    productivityWeekly: function (productivity, week, year) {
      const prod = productivity.find(
        prod => prod.week == week && prod.year == year
      )?.productivity;
      return this.numberWithPrecision(prod, 2);
    }
  }
};
</script>
